<mat-spinner class="spinner" *ngIf="loading"></mat-spinner>
<section class="section-b-space" *ngIf="!loading">
    <div class="container padding-cls">
        <mat-card class="margin-card">
            <div class="checkout-page">
                <div>
                    <form [formGroup]="checkoutForm">
                        <div class="row">
                            <div class="col-lg-6 col-sm-12 col-xs-12">
                                <div class="checkout-title">
                                    <h3>{{'checkout.billing-details' | translate}}</h3>
                                </div>
                                <div class="row p-3">
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="firstname">{{'customer-name' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['firstname']"
                                                type="text" id="firstname" name="firstname" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.required">
                                                {{'customer-name-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-6 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="lastname">{{'customer-lastname' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['lastname']"
                                                type="text" id="lastname" name="lastname" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.lastname.touched && checkoutForm.controls.lastname.errors?.required">
                                                {{'customer-lastname-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-6 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="phone">{{'customer-phone' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['phone']" type="text"
                                                id="phone" name="phone" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required">
                                                {{'customer-phone-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-6 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="email">{{'customer-email' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['email']" type="text"
                                                id="email" name="email" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.required">
                                                {{'customer-email-required' | translate}}
                                            </mat-hint>
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.email">
                                                {{'customer-email-invalid' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-12 col-sm-6 col-xs-12"    >
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>{{'branch' | translate}}</mat-label>
                                            <mat-select [formControl]="checkoutForm.controls['branch']">
                                                <mat-option *ngFor="let branch of branchList" [value]="branch.id">
                                                    {{branch.businessName}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-hint class="text text-danger"
                                                      *ngIf="checkoutForm.controls.branch.errors?.required">
                                                {{'checkout-branch-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-12 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="address">{{'customer-address' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['address']" type="text"
                                                id="address" name="address" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.address.touched && checkoutForm.controls.address.errors?.required">
                                                {{'customer-address-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-12 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="city">{{'customer-city' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['town']" type="text"
                                                id="city" name="city" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.town.touched && checkoutForm.controls.town.errors?.required">
                                                {{'customer-city-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-12 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="state">{{'customer-state' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['state']" type="text"
                                                id="states" name="states" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.town.touched && checkoutForm.controls.town.errors?.required">
                                                {{'customer-state-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class=" col-md-12 col-sm-6 col-xs-12">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label for="state">{{'customer-postalcode' | translate}}</mat-label>
                                            <input matInput [formControl]="checkoutForm.controls['postalcode']"
                                                type="text" id="state" name="state" autocomplete="off">
                                            <mat-hint class="text text-danger"
                                                *ngIf="checkoutForm.controls.postalcode.touched && checkoutForm.controls.postalcode.errors?.required">
                                                {{'customer-postalcode-required' | translate}}
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-sm-12 col-xs-12">
                                <div class="checkout-details">
                                    <div class="order-box">
                                        <div class="title-box col-12">
                                            <div>{{'product' | translate}} <span> Total</span></div>
                                        </div>
                                        <ul class="qty col-12 listItems" *ngIf='checkOutItems.length' >
                                            <li *ngFor="let item of checkOutItems">
                                                <div class="row">
                                                    <div class="col-8">
                                                        {{ item.product.name }} x <b>{{ item.quantity }}</b>
                                                    </div>
                                                    <div class="col-4">
                                                        <span>
                                                            {{ getPrice(item) * item.quantity | currency:productsService?.currency:'symbol' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul class="qty" *ngIf='!checkOutItems.length'>
                                            <li class="empty-checkout"> {{'cart-empty' | translate}} </li>
                                        </ul>
                                        <ul class="sub-total col-12">
                                            <li>
                                                Subtotal 
                                                <span class="count">
                                                    {{ getTotal() | async | currency:productsService?.currency:'symbol'}}
                                                </span>
                                            </li>
                                        </ul>
                                        <ul class="total col-12">
                                            <li>
                                                <b>Total 
                                                    <span class="count">
                                                        <b>{{ getTotal() | async | currency:productsService?.currency:'symbol'}}</b>
                                                    </span>
                                                </b>
                                            </li>
                                        </ul>
                                    </div>
                                    <button [routerLink]="['/home']" mat-stroked-button color="primary" class="btn-pago">
                                        {{'cart-table.continue-shopping' | translate}}
                                    </button>
                                    <button mat-stroked-button
                                            color="primary"
                                            class="btn-pago"
                                            [disabled]="!checkoutForm.valid"
                                            (click)="stripeCheckout()">
                                        {{'checkout.place-order' | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                 <!--       <div class="container-pago">
                            <div class="mpago" *ngIf='checkOutItems.length'>
                                <h3>Pagá en el local</h3>
                                <p>
                                    Preparamos tu pedido y pagas en el local.<br> 
                                    Podés utilizar varios métodos de pago.
                                </p>
                                <button mat-raised-button color="primary" class="btn-pago"
                                    [disabled]="!checkoutForm.valid"
                                    (click)="stripeCheckout()">
                                    {{'checkout.place-order' | translate}}
                                </button>                                                                                           
                            </div>
                             <app-mercado-pago
                                [formGroup]="checkoutForm" 
                                [armarListadoProductos]="armarListadoProductos()"
                                [getBasketCustomer]="getBasketCustomer()"
                                [getCustomer]="getCustomer()"
                                [getBranch]="getBranch()"
                            >
                            </app-mercado-pago>
                        </div>-->
                    </form>
                </div>
            </div>
        </mat-card>
    </div>
</section>
